import { render } from "./jobs_advertised.html?vue&type=template&id=4225a558&scoped=true&external"
import script from "./jobs_advertised.js?vue&type=script&lang=js&external"
export * from "./jobs_advertised.js?vue&type=script&lang=js&external"

import "./JobsAdvertised.vue?vue&type=style&index=0&id=4225a558&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4225a558"]])

export default __exports__